import React, { useEffect } from "react";
import { useQuery } from "react-query";
import { QUERIES } from "../../../config/apiConfig";
import axios from "../../../config/axiosInstance";
import DrawerLoading from "../../DrawerLoading";
import PositivoPlusCNPJQuery from "../../queries/PositivoPlusCNPJQuery";
import PositivoPlusCPFQuery from "../../queries/PositivoPlusCPFQuery";
import ScrBacenScoreQuery from "../../queries/ScrBacenScoreQuery";
import CompletaPlusCNPJQuery from "../../queries/CompletaPlusCNPJQuery";
import EssencialPlusCNPJQuery from "../../queries/EssencialPlusCNPJQuery";

const queries = [
  {
    id: 1,
    name: "Completa Plus CNPJ",
    component: <EssencialPlusCNPJQuery />,
  },
  {
    id: 2,
    name: "Completa Plus CPF",
    component: <CompletaPlusCNPJQuery />,
  },
  {
    id: 5,
    name: "Sim Scr + Score",
    component: <ScrBacenScoreQuery />,
  },
  {
    id: 3,
    name: "Essencial Plus CNPJ",
    component: <PositivoPlusCNPJQuery />,
  },
  {
    id: 4,
    name: "Essencial Plus CPF",
    component: <PositivoPlusCPFQuery />,
  },
];

const SelectedQueryReview = ({ query }) => {
  const {
    isLoading,
    error,
    data: queryData,
  } = useQuery(
    ["queryData", query],
    async () => {
      const { data } = await axios.get(
        `${QUERIES.GET_USER_QUERY}/${query?.id}`
      );

      return data.data;
    },
    {
      enabled: !!query,
    }
  );

  const getComponentByQueryId = (queryId) => {
    const queryMatch = queries.find((q) => q.id === queryId);
    if (!queryMatch) return <div>Consulta não reconhecida</div>;

    return React.cloneElement(queryMatch.component, {
      dataFromLocalStorage: queryData?.data, // se o componente usar
    });
  };

  return (
    <div className="relative">
      {queryData && (
        <>{queryData && getComponentByQueryId(queryData?.QueryId)}</>
      )}
      {isLoading && <DrawerLoading />}
    </div>
  );
};

export default SelectedQueryReview;
